import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const spinCampaignsRoutes = {
  name: 'spin-campaign',
  path: 'spin-campaign',
  component: () => import('./SpinCampaigns.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
